import { Component, Input, OnInit } from '@angular/core';
import { MarketProduct } from '../_models/product.interface';
import { Observable, of } from 'rxjs';
import * as cartActions from "../state/shopping-cart/cart-action";
import { ToastrService } from 'ngx-toastr';
import * as productsSelectors from '../state/product-list/list-selectors';
import { Store } from '@ngrx/store';
import { PushToCartComponent } from '@app/marketplace/shared/_components/push-cart.component';
import { UrlService } from '@app/services/url.service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';

@Component({
  selector: 'app-product-tab2',
  templateUrl: './product-tab2.component.html',
  styleUrls: ['./product-tab2.component.css']
})
export class ProductTab2Component extends PushToCartComponent implements OnInit {
  @Input()
  data$ :Observable<MarketProduct[]>;
  isLoading$: Observable<boolean>;
  count$: Observable<number>;
  theme = {'min-width': '273px','min-height' : '219px',background: '#f1f1f1'};
  constructor(
    private store: Store<any>,
    private urlService: UrlService,
    private metaService: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router ) {
     super(route,metaService,titleService,router);
     this.data$ = of([]);
     this.isLoading$ = this.store.select(productsSelectors.selectLoading);
     this.count$ = this.store.select(productsSelectors.selectCount);
  }
  ngOnInit(): void {}
  public pushToCart(product:any) {
    var itemImg = $(`#${product.code}`).find('img').eq(0);
    this.flyToElement($(itemImg),product,ViewTypeEnum.ProductList,this.store);
  }
}
